import { render, staticRenderFns } from "./historicoCodigosNuevo.vue?vue&type=template&id=0ae268d7&scoped=true"
import script from "./historicoCodigosNuevo.vue?vue&type=script&lang=js"
export * from "./historicoCodigosNuevo.vue?vue&type=script&lang=js"
import style0 from "./historicoCodigosNuevo.vue?vue&type=style&index=0&id=0ae268d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae268d7",
  null
  
)

export default component.exports